import { STARDOG_CONTEXT_LOCAL_IRI } from 'bones/constants/iris';
import type { QueryBuilderModel } from 'bones/utils/queryBuilder/model';

export interface VoiceboxSettings {
  databaseId: string;
  namedGraphs: string[];
  model: string;
  reasoning: boolean;
}

export const DEFAULT_VOICEBOX_SETTINGS: VoiceboxSettings = {
  databaseId: '',
  model: '',
  namedGraphs: [STARDOG_CONTEXT_LOCAL_IRI],
  reasoning: true,
};

export interface VoiceboxDatabase {
  examples: string[];
  id: string;
  isMediaEnabled: boolean;
  modelGraphs: Record<string, string[]>;
  models: string[];
  namespaces: Record<string, string>;
}

export interface VoiceboxNamedGraph {
  iri: string;
  aliasIris: string[];
  isAlias: boolean;
  isVirtual: boolean;
}

export type VoiceboxNamedGraphs = Record<string, VoiceboxNamedGraph>;

export interface VoiceboxSettingsContextValue {
  catalogProvidersLoading: boolean;
  catalogProvidersMissing: boolean;
  databasesById: Record<string, VoiceboxDatabase>;
  databasesLoading: boolean;
  descriptionsByDatabaseModel: Record<string, Record<string, string>>;
  descriptionsLoading: boolean;
  modelsByDatabaseId: Record<string, Record<string, QueryBuilderModel>>;
  modelsLoading: boolean;
  namedGraphFilter: string;
  namedGraphsByDatabaseId: Record<string, VoiceboxNamedGraphs>;
  namedGraphsLoading: boolean;
  setNamedGraphFilter: React.Dispatch<React.SetStateAction<string>>;
  setSettings: React.Dispatch<React.SetStateAction<VoiceboxSettings>>;
  settings: VoiceboxSettings;
  lastSettingsLoading: boolean;
  lastSettingsRefetching: boolean;
}
